<mat-dialog-content>
  <div class="container">
    <p translate [translateParams]="{title: cInteractiveLayer?.title | plain}">project.interactive.custom.info.remove</p>
    <footer class="buttons">
      <button mat-button class="cancel-button" (click)="close.emit()">{{'system.label.cancel' | translate}}</button>
      <button mat-button class="submit-button" (click)="onSubmit()">{{'system.label.remove' | translate}}</button>
    </footer>
  </div>
</mat-dialog-content>
